import { render, staticRenderFns } from "./EventReportEventModal.vue?vue&type=template&id=01f3f4e1&"
import script from "./EventReportEventModal.vue?vue&type=script&lang=js&"
export * from "./EventReportEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EventReportEventModal.vue"
export default component.exports